import * as React from 'react';
import { Col} from 'reactstrap';
import './tile.css';

export interface ITileProps {
    size?: number;
    offset?: number;
    caption: string;
    onClick: (itemId: number)=>void;
    item: any;
    iconName?: string;
}
 

class Tile extends React.Component<ITileProps > {
    constructor(props: ITileProps) {
        super(props);
        this.state = {   };
    }
  public  render() { 
      const val=()=>this.props.onClick(this.props.item);
        return (<Col xs={{size: this.props.size || 4, offset:this.props.offset || 0}}>
            <div className="tile" onClick={val}>
            <div className="tile-icon"><i className={"fa fa-" + (this.props.iconName || "home")} title={this.props.caption}/></div>
            <h3 className="title text-content">
            {this.props.caption === "FI to FI transfers" ? "FI to FI transfers (pacs.009)" : this.props.caption}
                <i className="fa fa-angle-right chevron" aria-hidden="true" />
            </h3>
            </div>
        </Col>);
    }
}
 
export default Tile;


// WEBPACK FOOTER //
// ./src/components/tile/tile.tsx